function getUserId() {
	return $.cookie('userId');
}

function setUserId(id) {
	$.cookie('userId', id, {
		expires: 365,
		path: '/'
	});
}
var UA = (function () {
	var products = [];
	var promotions = [];
	var defaults = {
		product: {
			visible: false,
			sent: false,
			variant: ""
		},
		promotion: {
			name: '',
			position: 0,
			width: 0,
			height: 0
		}
	};
	var disabled = {
		productImpressions: false,
		productImpressionsAccesories: true
	};
	var isAccesoriesDisabled = function (list) {
		return disabled.productImpressionsAccesories;
	};

	var generatePromotionDate = function (promotion, all) {
		var $element = $('.js-UA-promotion:visible').filter("[data-id=" + promotion.id + "]");
		var width = 0;
		var height = 0;
		var data;
		var $img;
		if ($element.length || all) {
			$img = $element.find('img');
			width = Math.round(promotion.width || parseFloat($img.width()));
			height = Math.round(promotion.height || parseFloat($img.height()));
			data = {
				id: promotion.type + '_' + promotion.id.split("-")[0],
				name: promotion.name,
				creative: (promotion.area) ? promotion.area.column + '_' + promotion.area.name : 'productAdvertisingPlacement', //app.pageType(),
				position: width + 'x' + height
			};

			return data;
		} else {
			return false;
		}

	};

	var cancelOrder = function (orderNumber) {
		var date = new Date(),
			year = date.getFullYear(),
			fullOrderNumber = orderNumber + "/" + year.toString();

		push({
			'ecommerce': {
				'refund': {
					'actionField': {
						'id': fullOrderNumber
					}
				}
			}
		});
	};

	var auth = function () {
		push({
			'userId': getUserId() || '',
			'event': 'authentication'
		});
	};

	var userId = function () {
		var id = getUserId();
		if (id) {
			push({
				'userId': id,
			});
		}
	};

	var allPush = [];
	var getPush = function () {
		return $.extend(true, [], allPush);
	};

	function sendFallbackData(callbackSuccess) {
		if (online === true) {

		} else if (online === false) {
			callbackSuccess();
		} else {
			setTimeout(function () {
				sendFallbackData(callbackSuccess);
			}, 500);
		}
	}
	var tmpPush = [];
	var push = function (params) {
		if (online === true || online === false) {
			try {
				if (online === false && (params.event === 'virtualPageview' || params.event === 'orderComplete' || params.userIncognito || params.userAdblock || params.event === 'cart_step')) {
					app.setFallbackData(params);
				} else {
					window.dataLayer = window.dataLayer ? window.dataLayer : [];
					window.dataLayer.push(params);
				}
				const showLog = (location.port.indexOf(8080) > -1 || location.host.indexOf('qa') > -1 || localStorage.getItem('showLog') == 'true' || isAtr ? true : false);
				if (showLog) {
					console.log('UA PUSH', params);
				}
				allPush.push(params);
			} catch (error) {
				console.log('UA PUSH ERROR: ' + error);
			}
		} else {
			tmpPush.push(params);
		}
	};

	var pageInteraction = function () {
		var pages = {
			"product": 'KP',
			"leaf": 'Listing'
		};
		var params = [];
		params.push(pages[app.pageType()]);
		$(arguments).each(function (i, n) {
			params.push(n);
		});
		interaction(params);
	};
	var interaction = function () {
		var params = arguments[0];
		if (arguments[1]) {
			params = arguments;
		}
		if (params[0]) {
			push({
				'event': 'visitorInteraction',
				'eventCategory': params[0],
				'eventAction': params[1] || '',
				'eventLabel': params[2] || '',
				'eventValue': params[3] || '',
				'eventNonInteraction': params[4] || ''
			});
		}
	};
	var firstPageView = true;
	var lastPageUrl = '';
	var pageview = function (url) {
		var data = {
			'event': 'virtualPageview',
			'virtualPageURL': undefined
		};
		if (url) {
			data.virtualPageURL = url;
		} else if (pageUrl) {
			data.virtualPageURL = pageUrl;
		}
		firstPageView = false;
		if (lastPageUrl !== data.virtualPageURL) { //jesli adres sie nie zmienil, nie wysylamy
			push(data);
		}
		lastPageUrl = data.virtualPageURL;
	};

	var pageUrl = null;
	var setPageUrl = function (url) {
		var params = $.parseQuery();
		if (params.link && url.indexOf('link=') === -1) {
			url += '&link=' + params.link;
		}
		if (params.from && url.indexOf('from=') === -1) {
			url += '&from=' + params.from;
		}
		pageUrl = url;
	};
	var removePageUrl = function () {
		pageUrl = '';
	};

	function userLogged() {
		var cookie = $.cookie('userLogged');
		if (cookie) {
			setUserId(cookie); //globalnie
			auth();
			$.cookie('userLogged', '', {
				expires: -1
			});
		}
	}

	function uniquePush(data, id) {
		if (window.sessionStorage.getItem("orderFinalize") !== id) {
			window.sessionStorage.setItem('orderFinalize', id);
			push(data);
		}
	}
	
	var orderFinalizeData = false;
	var saveOrderFinalize = function (data) {
		orderFinalizeData = Object.assign({}, data);
	}
	var orderFinalize = function () {
		var isValid = orderFinalizeData && orderFinalizeData.ecommerce;

		if (isValid) {
			var id = orderFinalizeData.ecommerce.purchase.actionField.id;
			uniquePush(Object.assign({}, orderFinalizeData), id);
		}
		orderFinalizeData = false;
	}
	var pageCategory = function () {
		push({
			'pageCategory': app.pageType(),
			'front': app.getBrakepoint(),
			'url': document.location.href,
			'cannonical-url': document.location.protocol + '//' + document.location.host + document.location.pathname
		});
	};

	var userAdblock = function () {
		push({
			userAdblock: online ? 'off' : 'on'
		});
	}

	var userIncognito = function () {
		const isIncognito = new Promise(function (resolve, reject) {
			if (/Chrome/.test(navigator.userAgent)) {    //dotyczy wszystkich przegladarek na silniku Chromium - takze przegladarki Edge
				const limit = performance.memory.jsHeapSizeLimit || 1073741824;   //limit pamięci dla chrome - wynik poniżej tej wartości wskazuje na tryb incognito; dla wersji <77 ustalona stala wartosc
				navigator.webkitTemporaryStorage.queryUsageAndQuota(function (_, memorySize) {
					resolve(memorySize < limit);
				});
			} else if (/Firefox/.test(navigator.userAgent)) {
				const db = indexedDB.open('test'); //wartosc defaultowa dla indexedDB to 'test'
				db.onerror = function () {  //indexedDB nie jest dostępny dla trybu prywatnego - w tym przypadku zadziała metoda onerror()
					resolve(true);
				};
				db.onsuccess = function () {
					resolve(false);
				}
			} else if (/Safari/.test(navigator.userAgent)) {
				const storage = window.sessionStorage;
				try {
					storage.setItem("testKey", "test");
					storage.removeItem("testKey");
					resolve(false);
				} catch (error) {   //w trybie inPrivate Safari blokuje zapis do sessionStorage
					if (error.code === DOMException.QUOTA_EXCEEDED_ERR && storage.length === 0) {
						resolve(true);
					}
				}
			} else { //dla pozostalych przegladarek nic nie wysylamy
				reject();
			}
		});

		isIncognito.then(function (isIncognito) {
			push({
				userIncognito: isIncognito ? 'on' : 'off'
			});
		})
	}

	var error = function (page) {
		var url = "/blad-decoration-error" + document.location.pathname + document.location.search;
		if (page) {
			url += '/bloczek=' + page;
		}
		pageview(url);
	};

	var init = function () {
		pageview();
		pageCategory();
		userLogged();
		userId();
	};
	var online = null;
	if (window.sessionStorage.getItem('UA') === 'online') {
		online = true;
	} else if (window.sessionStorage.getItem('UA') === 'offline') {
		online = false;
	} else {
		$.ajax({
			url: 'https://www.google-analytics.com/collect',
			success: function (h) {
				online = true;
			},
			error: function () {
				online = false;
			},
			complete: function () {
				window.sessionStorage.setItem('UA', online ? 'online' : 'offline');
				if (tmpPush.length) {
					tmpPush.forEach((item, i) => {
						push(item);
					});
					tmpPush = [];
				}
				//wysylamy do analityki tylko raz na sesje
				userAdblock();
				userIncognito();
			}
		});
	}

	return {
		init: init,
		auth: auth,
		push: push,
		error: error,
		getPush: getPush,
		pageCategory: pageCategory,
		sendFallbackData: sendFallbackData,

		interaction: interaction,
		pageview: pageview,

		setPageUrl: setPageUrl,
		removePageUrl: removePageUrl,
		cancelOrder: cancelOrder,
		orderFinalize: orderFinalize,
		saveOrderFinalize: saveOrderFinalize,

		pageInteraction: pageInteraction,
	};
})();
